import { Injectable } from '@angular/core';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { User } from '@xpo-ltl/sdk-common';
import * as _ from 'lodash';
import { AppRoleService } from './app-role.service';
import { ConfigManagerProperties } from '../../enums/config-manager-properties.enum';
import { UserRole } from '../../enums/user-role.enum';

@Injectable({ providedIn: 'root' })
export class UserRoleService {
  user: User;
  private isProduction = false;
  private roleNames = {};
  private readonly removeDomainRegExp = /.*\//gm;

  constructor(
    private configManagerService: ConfigManagerService,
    private appRoleService: AppRoleService
  ) {
    this.isProduction =
      this.configManagerService.getSetting<string>(ConfigManagerProperties.buildVersion) === 'local-version';

    /** TODO: establish roles for PROD / NON-PROD */
    this.roleNames = {
      [UserRole.User]: this.isProduction ? 'everyone' : ['everyone'],
      [UserRole.SuperUser]: this.isProduction ? 'DEFAULT_TABIGATOR' : ['DEFAULT_TABIGATOR'],
    };
  }

  /** TODO: an authorized user can have any set of roles defined above... */
  isAuthorizedUser(user: User): boolean {
    const actions = this.appRoleService.getActions();
    return (
      (this.hasRole(user.roles, this.roleNames[UserRole.User]) ||
        this.hasRole(user.roles, this.roleNames[UserRole.SuperUser])) &&
      !!actions.length &&
      !!actions
    );
  }

  /** TODO: some authorized users may have mutliple roles... see role-check-guard.ts as it handles this!!! */
  hasMultipleRoles(user: User): boolean {
    return (
      this.hasRole(user.roles, this.roleNames[UserRole.User]) &&
      this.hasRole(user.roles, this.roleNames[UserRole.SuperUser])
    );
  }

  get isBasicUser(): boolean {
    return this.hasRole(this.user.roles, this.roleNames[UserRole.User]);
  }

  get isSuperUser(): boolean {
    return this.hasRole(this.user.roles, this.roleNames[UserRole.SuperUser]);
  }

  private hasRole(userRoles: string[], roleOf: any): boolean {
    const roleOfArray = _.castArray(roleOf);
    const splitUserRolesArr = _.map(userRoles, (role: string) => {
      return role.replace(this.removeDomainRegExp, '');
    });
    const results = _.intersectionBy(splitUserRolesArr, roleOfArray, (value) => value.toUpperCase());
    return !!results && !!results.length;
  }

  setRole(role: UserRole) {
    if (!!this.user && !this.configManagerService.getSetting<boolean>(ConfigManagerProperties.production)) {
      const roleEnum = this.getUserRoleEnum(role);
      if (!!roleEnum) {
        this.user.roles.length = 0;
        _.castArray(this.roleNames[roleEnum]).forEach((roleName) => this.user.roles.push(roleName));
      }
    }
  }

  getRole(): UserRole {
    if (this.hasRole(this.user.roles, this.roleNames[UserRole.User])) {
      return UserRole.User;
    }
    if (this.hasRole(this.user.roles, this.roleNames[UserRole.SuperUser])) {
      return UserRole.SuperUser;
    }
  }

  private getUserRoleEnum(value: string): UserRole {
    for (const obj in UserRole) {
      if (UserRole[obj] === value) {
        return UserRole[obj] as UserRole;
      }
    }
  }
}
